import React from 'react';
import styled from 'styled-components';
import { Spring, animated } from 'react-spring';

const Contaner = animated(styled.div`
  position: relative;
  z-index: 1;
`);

export default ({ config, from, to, children, ...rest }) => (
  <Spring native from={from || { opacity: 0 }} to={to || { opacity: 1 }} config={config || { delay: 200 }}>
    {animation => (
      <Contaner style={animation} {...rest}>
        {children}
      </Contaner>
    )}
  </Spring>
);
